import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { CostStatuses } from 'src/app/shared/models/cost.model';
import { Roles } from 'src/app/shared/models/auth/role.model';
import { CostActionsService } from 'src/app/shared/services/cost-actions.service';
import { of } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cost-actions-bottom',
  templateUrl: './cost-actions-bottom.component.html',
})
export class CostActionsBottomComponent implements OnInit, OnChanges {

  @Input() costStatus: CostStatuses;
  @Input() costType;
  @Input() roles: Roles[];
  @Input() canCurrentUserMakeAction: boolean;
  @Input() hasCreatedThisCost: boolean;
  @Input() approvalPathStepName;
  @Input() isThisNewCostPage;
  @Input() costFormInvalid;
  @Output() actionEmitter = new EventEmitter();
  costOptions$;

  constructor(
    private costActionsService: CostActionsService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  ngOnChanges(change) {

    if (!this.isThisNewCostPage && (change['costStatus'] || change['approvalPathStepName'])) {
      this.costOptions$ = of(
        this.costActionsService.getCostOptions(this.costStatus, this.roles, this.canCurrentUserMakeAction, this.hasCreatedThisCost)
      );

    }

  }


  cancelCostCreation() {
    this.router.navigate(['dashboard']);
  }

  emitAction(action) {
    this.actionEmitter.emit(action);
  }
}
